import React, { Component } from 'react'
import GoogleLogin from 'react-google-login';
import { GoogleLogout } from 'react-google-login';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';

class GoogleAuth extends Component {

	 responseGoogle = (response) => {
		this.props.loginUser(response.profileObj.name, response.profileObj.googleId, response.profileObj.imageUrl, "GoogleSSO")
		// console.log(response.profileObj);
	  }

	  handleFailure = (response) => {
		// console.log(response.profileObj);
	  }
	  
	  HandleLogout = () => {
		this.props.logoutUser()
		if (localStorage.getItem('jwt')) {
			this.props.history.push("/")
			localStorage.removeItem('jwt') 
		  }
		}
	
	   checkLoggedIn = () => {
		//   console.log(this.props.isLoggedIn)
		if (this.props.isLoggedOut) {
			return (
				<GoogleLogin
				clientId="196914294557-lco1nhlo6ejo1l3c7gtmq6ntqed9qh8p.apps.googleusercontent.com"
				buttonText="Login"
				onSuccess={this.responseGoogle}
				onFailure={this.handleFailure}
				cookiePolicy={'single_host_origin'} /> 
			)
		} else if (this.props.isLoggedIn) {
			return (
				<GoogleLogout
				clientId="196914294557-lco1nhlo6ejo1l3c7gtmq6ntqed9qh8p.apps.googleusercontent.com"
				buttonText="Logout"
				onLogoutSuccess={this.HandleLogout}
				onFailure={this.handleFailure}>
				</GoogleLogout>
			)
		} 
		else {
			return null
		}
	}
	render(){
		return this.checkLoggedIn()
	}
}

const msp = state => {
	return {
		placeholder: "placeholder",
	}
  };
  
  export default connect(msp)(withRouter(GoogleAuth))